const joinConsentNameWithDotNotation = (
  parentConsentNamePrefix: string,
  childConsentName: string,
) => `${parentConsentNamePrefix}.${childConsentName}`;

const isBoolean = (value: unknown): value is boolean => typeof value === 'boolean';

const isNotNullRecord = (
  value: unknown,
): value is Record<string, object> => typeof value === 'object' && value !== null;

const flattenConsentValue = (
  parentName: string,
  consentValue: Record<string, unknown>,
  totalFlattenedConsentValues: Record<string, boolean> = {},
): Record<string, boolean> => {
  const flattenedConsentValues = Object.entries(consentValue)
    .reduce((consentValues, [name, value]) => {
      const joinedConsentName = joinConsentNameWithDotNotation(parentName, name);

      return {
        ...consentValues,
        ...(isBoolean(value) && { [joinedConsentName]: value }),
        ...(isNotNullRecord(value) && flattenConsentValue(joinedConsentName, value)),
      };
    }, {} as Record<string, boolean>);

  return {
    ...totalFlattenedConsentValues,
    ...flattenedConsentValues,
  };
};

export const flattenDotNotationConsentValues = (
  consentsValues: Record<string, unknown>,
): Record<string, boolean> => Object.entries(consentsValues)
  .reduce((flattenedConsentValues, [name, value]) => ({
    ...flattenedConsentValues,
    ...(isBoolean(value) && { [name]: value }),
    ...(isNotNullRecord(value) && flattenConsentValue(name, value)),
  }), {} as Record<string, boolean>);
